import React from 'react'
import { Link } from 'react-router-dom';

const ErrorMessage = ({isOpen, message, onClose}) => {

    if (!isOpen) return null;

  return (
    <div className="fixed rounded-md w-full inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white w-1/2 p-6 rounded shadow-lg z-10 px-16 py-10">
        <div className="flex items-center gap-5 border-b-2 my-2 pb-3 border-gray-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="red"
            className="bi bi-exclamation-triangle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
          </svg>
          <h2 className="text-2xl font-bold">Error</h2>
        </div>

        <p className="text-sm my-2">{message}</p>
        <div className="flex gap-5 w-full justify-center text-md font-semibold">
          <button className="mt-4 w-1/2 px-4 py-2 border border-red-500 text-red-500 rounded">
            <Link to="/">Try Again</Link>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorMessage;